(function () {
  var track = document.querySelector('.rv-track');
  var prev = document.querySelector('.rv-btn-nav.rv-prev');
  var next = document.querySelector('.rv-btn-nav.rv-next');

  if (!track) return;

  function getCardWidth() {
    var card = track.querySelector('.rv-card');
    if (!card) return 316;
    return card.offsetWidth + 16;
  }

  if (prev) {
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
    });
  }
})();
